/**
 * フロントに必要な情報を保持するVOクラス
 */
export class GetInitTopModel {
    /** ユーザID */
    public UserID = '';
    /** 権限セットID */
    public AuthoritySetID = '';
    /** 管理者区分 */
    public AdminDiv = '';
    /** 機能許可データ */
    public PermissionList: PermissionModel[];
    /** パスワード残日数 */
    public PwdLimitDay = '';
    /** マニュアルパス */
    public Manual = '';
    /** バイヤーコードリスト */
    public BuyerCodeList = [];
    /** ユーザ区分(1:取引先（卸）、2:スタジオ、3:制作会社) */
    public AssociatedUserType = '';
    /** 取引先コード */
    public SupplierCode = '';
    /** ユーザ階層リスト */
    public UserClassList: UserClassListModel[];
    /** 企画支援会社フラグ */
    public PlanningSupportFlg = '';
    /** SAML認証フラグ */
    public SamlAuthFlg = '';
}

/**
 * 機能許可データモデル
 */
export class PermissionModel {
    constructor(
        /**  機能ID */
        public FuncID: string,
        /** 機能名 */
        public Funcname: string,
        /** 活性モード */
        public EnableMode: string,
    ){}
}

/**
 * ユーザー階層リストモデル
 */
export class UserClassListModel {
    constructor(
        /** 部門コード */
        public ClassCode: string,
        /** ユーザ階層(0:グループ長、1:担当者、2:代行者) */
        public UserClass: string,
    ){}
}